import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { H2 } from "components/ui/Typography";
import InvestmentDetailsCard from "components/InvestmentDetailsCard";
import InvestmentFundsCard from "components/InvestmentFundsCard";
import InvestmentAmountCard from "components/InvestmentAmountCard";
import ChargesCard from "components/ChargesCard";
import { Button, NavigationFooter } from "./styles";
import { useReportDetails } from "./hooks";

function ReportDetails() {
  const { continuteButtonDisabled } = useReportDetails();
  const url = continuteButtonDisabled ? "" : "reportingperiod";

  return (
    <Container>
      <Row>
        <Col>
          <H2>Report details</H2>

          <InvestmentDetailsCard />

          <InvestmentFundsCard />

          <InvestmentAmountCard />

          <ChargesCard />

          <NavigationFooter>
            <Link to={url}>
              <Button disabled={continuteButtonDisabled}>Continue</Button>
            </Link>
          </NavigationFooter>
        </Col>
      </Row>
    </Container>
  );
}

export default ReportDetails;
